import React from 'react'

const DotsMenuIcon = () => {
  return (
    <svg width="4" height="17" viewBox="0 0 4 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 1.5C3.5 2.32837 2.82837 3 2 3C1.17163 3 0.5 2.32837 0.5 1.5C0.5 0.671631 1.17163 0 2 0C2.82837 0 3.5 0.671631 3.5 1.5ZM3.5 8.5C3.5 9.32837 2.82837 10 2 10C1.17163 10 0.5 9.32837 0.5 8.5C0.5 7.67163 1.17163 7 2 7C2.82837 7 3.5 7.67163 3.5 8.5ZM2 17C2.82837 17 3.5 16.3284 3.5 15.5C3.5 14.6716 2.82837 14 2 14C1.17163 14 0.5 14.6716 0.5 15.5C0.5 16.3284 1.17163 17 2 17Z" fill="#2B244C"/>
    </svg>
    
  )
}

export default DotsMenuIcon